export const getOppositeFlexDirection = (flexDirection) => {
    if (flexDirection.startsWith('row')) {
        return flexDirection === 'row' ? 'rowReverse' : 'row';
    }
    return flexDirection === 'column' ? 'columnReverse' : 'column';
};
export const convertFlexDirectionToCssFlexDirection = (flexDirection) => {
    switch (flexDirection) {
        case 'rowReverse':
            return 'row-reverse';
        case 'columnReverse':
            return 'column-reverse';
        default:
            return flexDirection;
    }
};
//# sourceMappingURL=flexStylesUtils.js.map